import firebaseConfig from './firebase_config'
var defaultExport={}

//FireBase - //Since version 6.0.0 , config is fetched from firebase_config.js - for easier setup
defaultExport.firebaseConfig = firebaseConfig.config;

//App setup
defaultExport.adminConfig={
  "appName":"CCC BookRoom Management Tool",
  "slogan":"Provided by X2Mobile",

  "design":{
    "sidebarBg":"sidebar-1.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"blue", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"black", // "white | black"
  },

  "showItemIDs":false,
  "allowedUsers":null, //If null, allow all users, else it should be array of allowd users
  "adminUsers":[""],
  "allowGoogleAuth":true, //Allowed users must contain list of allowed users in order to use google auth
  "allowRegistration":false, //Should there be register page
  "fieldBoxName": "Fields",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":[""],
  "showSearchInTables":true,
  "methodOfInsertingNewObjects":"push", //timestamp (key+time) | push - use firebase keys
  "goDirectlyInTheInsertedNode":false,
  "urlSeparator":"+",
  "urlSeparatorFirestoreSubArray":"~",
  "googleMapsAPIKey":"AIzaSyBUsBW0ZbMMtLsrUDIG5otUHrfiyQHEhOc",

  "fieldsTypes":{
    "photo":["coverUrl"],
    "dateTime":[],
    "map":[],
    "textarea":["isbn", "sortorder", "title", "type", "name", "code", "order", "transcript"],
    "html":[],
    "radio":[],
    "checkbox":[],
    "dropdowns":[],
    "file":["bookUrl", "sound"],
    "rgbaColor":[],
    "hexColor":[],
    "relation":["sectionlabel"],
    "iconmd":[],
    "iconfa":[],
    "iconti":[],
    "iconio":[],
  },
  "optionsForSelect":[],
  "optionsForRelation":[
    {
      "key":"sectionlabel", //Type of fields, always remains same
      "path":"/sections", //Path to the referenced data, ex Categories in article
      "value":"name", //What key to put in the "value" of the select
      "display":"name", //What key to put in the "name" of the select element
      "isValuePath":false, //If true, for the value we will put the value key, if false, we will use the path to the referenced object
      "produceRelationKey":false, //You will need new field automaticaly produced if you want to query the reference ex. Category -> Action
      "relationKey":"book_sectionid", //Name of the newly produced field
      "relationJoiner":"-" //How the values of the both object are joined ex. category_id-article_id
    }
  ],
  "hiddenKeys":[],
  "previewOnlyKeys":[],

  "paging":{
    "pageSize": 1000,
    "finite": false,
    "retainLastPage": false
  }
}

//Navigation
defaultExport.navigation=[
    {
      "link": "fireadmin",
      "path": "books",
      "name": "Books",
      "icon": "school",
      "tableFields":["bookUrl", "coverUrl", "isbn", "sectionlabel", "setno", "sortorder", "title", "type", "sound", "transcript"]
    },
    {
      "link": "fireadmin",
      "path": "sections",
      "name": "Sections",
      "icon": "collections_bookmark",
      "tableFields":["name", "code", "order"]
    }
  ];

  //From v 5.1.0 we suggest remoteSetup due to security
  //
defaultExport.pushSettings={
  "remoteSetup":false,
  "remotePath":"pushSettings",
  "pushType":"firebase", //firebase -  onesignal - expo
  "Firebase_AuthorizationPushKey":"AIzaSyD8bsQAj2vzO4STIzfi4NB7diKvjco-4O4", //Firebase push authorization ket
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"",
  "oneSignal_APP_KEY":"",
  "included_segments":"Active Users", //Only for onesignal push
  "firebasePathToTokens":"/firebasePushTokens", //we save expo push tokens in firebase db
  "saveNotificationInFireStore":true, //Should we store the notification in firestore
}

defaultExport.filesSettings={
  "filesPath":"/TESTFILES/"
}

//flag to now which app we are using to configure Languages Style
defaultExport.appToConfig="fireadmin"

defaultExport.userDetails={

}

defaultExport.activeTranslation={
  "dynamic" : {},
  "static" : {
    "Dashboard_Content": "The greatest admin panel to manage BookRoom database"
  }
};

defaultExport.remoteSetup=false;
defaultExport.remotePath="admins/book-room";
defaultExport.allowSubDomainControl=false;
defaultExport.subDomainControlHolder="admins/";
defaultExport.saasappadmindata="appadmin_pointers/data/"
defaultExport.isAppCreator=false;
defaultExport.appEditPath=undefined;
defaultExport.isDemo=false;
defaultExport.tinyMCEAPIKey=""

export default defaultExport;



// WEBPACK FOOTER //
// ./src/config/app.js